import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="flex min-h-screen items-center justify-center bg-ink-900"><span className="font-mono2 text-xs uppercase tracking-widest text-white/40">Loading…</span></div>;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
